export default __webpack_public_path__ + "static/wrv-top-1f0e2a2fa064b6821a6e725d52a5c77b.jpg";